import { Drawer, Group, Modal, Radio, ScrollArea, Stack, Text } from "@mantine/core";
import { useEffect, useRef } from "react";
import { times } from "./type";
import useIsSmall from "@/hooks/useIsSmall";

type Props = {
  openedTime: boolean;
  closeTime: () => void;
  currentTime: string;
  setCurrentTime: (time: string) => void;
};

function EditTime({
  openedTime,
  closeTime,
  currentTime,
  setCurrentTime,
}: Props) {
  const scrollAreaRef = useRef<HTMLDivElement>(null);
  const isSmall = useIsSmall();
  useEffect(() => {
    if (openedTime && currentTime) {
      const scrollToElement = () => {
        const targetElement = document.getElementById(`time-${currentTime}`);
        if (targetElement) {
          // Simple approach: just scroll the element into view
          targetElement.scrollIntoView({
            behavior: "instant",
            block: "center",
            inline: "nearest",
          });
        }
      };

      // Try multiple times with increasing delays to ensure drawer is fully rendered
      const attempts = [
        setTimeout(scrollToElement, 200),
        setTimeout(scrollToElement, 500),
        setTimeout(scrollToElement, 800),
      ];

      return () => {
        attempts.forEach(clearTimeout);
      };
    }
  }, [openedTime, currentTime]);

  const setCurrenTime = (time: string) => {
    setCurrentTime(time);
    closeTime();
  };

  const content = <Stack pt="md" h="calc(100svh - 305px)" justify="space-between">
    <Radio.Group
      value={currentTime}
      onChange={(time) => setCurrenTime(time)}
    >
      <ScrollArea ref={scrollAreaRef}>
        <Stack>
          {times?.map((item) => (
            <Radio.Card
              radius="md"
              value={item.value}
              key={item.label}
              withBorder={false}
              id={`time-${item.value}`}
            >
              <Group wrap="nowrap" justify="space-between">
                <Radio.Indicator />
                <Text>{item.value}</Text>
              </Group>
            </Radio.Card>
          ))}
        </Stack>
      </ScrollArea>
    </Radio.Group>
  </Stack>
  return (
    isSmall ?
      <Drawer
        opened={openedTime}
        onClose={closeTime}
        position="bottom"
        radius="md"
        title="زمان شروع"
        size="md"
      >
        {content}
      </Drawer> : <Modal opened={openedTime}
        onClose={closeTime} title="زمان شروع">
        {content}
      </Modal>
  );
}

export default EditTime;
